/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */

/**
 * Response schema for creating a Curai visit from a Nori conversation
 */
export interface CreateCuraiVisitResponse {
  /** The ID of the new Curai-type conversation in Nori */
  new_conversation_id: string;
}
